import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import TextEllipsis from '../../../../common/textEllipsis'
import classes from './index.module.scss'
import { changeName, selectIsFiinGateTemplate, selectName } from './store/slice'

const TemplateName = () => {
  const dispatch = useDispatch()

  const name = useSelector(selectName)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)

  const defaultName = useRef(name)
  const inputRef = useRef()

  const [isEdit, setIsEdit] = useState(false)

  const enableEdit = () => {
    setIsEdit(true)
    setTimeout(() => {
      inputRef.current?.focus()
    }, 200)
  }

  const disableEdit = () => {
    if (!name) {
      dispatch(changeName(defaultName.current))
    }

    setIsEdit(false)
  }

  const onChangeName = (e) => {
    dispatch(changeName(e.target.value))
  }

  return (
    <>
      <Translate
        style={{ fontWeight: 'unset' }}
        value="preferenceSetting.TEMPLATE_NAME"
      />
      &nbsp;&nbsp;
      {!isEdit ? (
        <span>
          <TextEllipsis text={name} isI18n={false} />
        </span>
      ) : (
        <Element
          ref={inputRef}
          elementName="input"
          className={classes.input}
          style={{ border: '1px solid #E0E0E0', color: '#3A414B' }}
          onBlur={disableEdit}
          onChange={onChangeName}
          value={name}
        />
      )}
      {!isFiinGateTemplate && (
        <Icon
          onClick={enableEdit}
          style={{ color: '#9C9C9C', fontSize: 15 }}
          className={`icon-edit-outline ${classes.iconEdit}`}
        />
      )}
    </>
  )
}

export default TemplateName
